<!-- (老的，临时用) -->
<template>
  <!-- 活动-眉笔活动-眉笔活动管理-活动配置弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="配置"
      width="600px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        size="small"
        :rules="replyRules"
        v-loading="loading"
      >
        <el-form-item label="页面显示：">
          <el-switch
            v-model="switchStatus"
            :active-value="1"
            :inactive-value="0"
            active-text="页面显示"
            inactive-text="页面关闭"
            @change="setSwitch"
          ></el-switch>
        </el-form-item>
        <el-form-item label="活动时间段：">
          <el-date-picker
            style="width: 200px"
            v-model="dataForm.start_time"
            :picker-options="pickerOptions"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            style="width: 200px"
            v-model="dataForm.end_time"
            :picker-options="pickerOptions"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动周期：">
          <el-input
            style="width: 200px"
            placeholder="请输入活动周期"
            v-model="dataForm.cycle"
          ></el-input>
        </el-form-item>
        <el-form-item label="房间金额：">
          <el-input
            style="width: 200px"
            placeholder="请输入房间金额"
            v-model="dataForm.min_room_price"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import AddGoods from '@/components/goods/AddGoods.vue'
import AddDebris from '@/components/debrisActivity/AddDebris.vue'

export default {
  components: {
    AddGoods,
    AddDebris
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      switchStatus: 0,//开关状态
      dataForm: {
        end_time: '',
        start_time: '',
        cycle: '',
        min_room_price: ''
      },
      pickerOptions: {
        disabledDate(date) {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          return date.getTime() < Date.now() - 8.64e7;
        }
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getSwitch()
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    //获取关闭/打开开关状态
    getSwitch() {
      getApiData('upgrade_brow_enable')
        .then(res => {
          if (res) {
            res.data ? this.switchStatus = 1 : this.switchStatus = 0
          }
        })
    },
    //关闭/打开开关
    setSwitch() {
      let params = { "black": this.switchStatus ? 1 : 0 }
      patchApiData('upgrade_brow_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getSwitch()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.switchStatus = this.switchStatus ? 0 : 1
        })
    },
    //获取表达数据
    getData() {
      this.loading = true
      getApiData('brow_pen').then((res) => {
        this.dataForm = res
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      //保存任务
      //表单验证后发起请求
      if ((this.dataForm.cycle % 1 != 0) || this.dataForm.cycle <= 0 || this.dataForm.zhouqi > 31) {
        this.$message.warning("周期必须为0-31的整数日")
        return
      }
      this.buttonLoading = true
      let params = this.dataForm
      patchApiData(`brow_pen/${this.dataForm.id}`, params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.closeDialog()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }
}

</script>
<style lang="less" scoped>
</style>